import React from 'react';
import { Chip } from '@mui/material';
import { EventCategory, CATEGORY_LABELS, CATEGORY_COLORS } from '../../types/event';

interface CategoryBadgeProps {
  category: EventCategory;
  size?: 'small' | 'medium';
}

export const CategoryBadge: React.FC<CategoryBadgeProps> = ({ category, size = 'small' }) => {
  const color = CATEGORY_COLORS[category];
  return (
    <Chip
      label={CATEGORY_LABELS[category]}
      size={size}
      variant="outlined"
      sx={{
        borderColor:     color,
        color:           color,
        backgroundColor: 'transparent',
        fontWeight:      600,
        fontSize:        size === 'small' ? '0.7rem' : '0.8rem',
        borderRadius:    '8px',
      }}
    />
  );
};
